import { useFormContext } from 'react-hook-form';

/**
 * Once a location has more than one shift the wizard stacks several identical-looking blocks of
 * steps on top of each other, so every step after the first shift names the shift it belongs to.
 * The first shift needs no label — there is nothing to tell it apart from yet.
 */
export const useShiftLabel = (shiftFieldName: string, shiftIndex: number): string => {
  const { watch } = useFormContext();
  const name = watch(`${shiftFieldName}.name`);

  if (!shiftIndex) {
    return '';
  }

  return ` (${name || `shift ${shiftIndex + 1}`})`;
};
